// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/Image/signUp-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  /* height: 100vh; */
  display: flex;
  flex-direction: column; /* Aligns children (main, footer) in a column */
  
  /* Corrected gradient background */
  background: 
   url(${___CSS_LOADER_URL_REPLACEMENT_0___}), linear-gradient(  #8FB940, #8AC813) ;
   /* background-repeat: no-repeat; */
  background-size: cover; /* Optional: Ensures the background covers the viewport */
  color: #fff; /* Makes text color white for better contrast */
  background-attachment: fixed;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}


.top-navbar {
  background-color: #602998;
}

.login-btn,
.signup-btn {
  height: 35px;
  padding: 10px 20px;
  text-align: center;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  text-transform: uppercase;
  border: 1.4px solid #8FB940;
  transition: background 0.3s, color 0.3s;

}

.login-btn-active {
  background-color: #8FB940 !important;
  color: #fff !important;
}

.signup-btn {
  background-color: transparent;
  color: #8FB940;
}

.login-btn:hover {
  background-color: transparent;
  color: #8FB940;
}

.signup-btn:hover {
  background-color: #8FB940;
  color: #fff;
}



.footer-container {
  position: fixed;
  /* z-index: 1; */
  /* margin-top: 2%; */
  display: flex;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #f8f9fa;
  padding: 10px 0;
  border-top: 1px solid #ddd;
}


.footer-container a {
  text-decoration: none;
  color: #000;
}

/* .footer-container a:hover {
  text-decoration: underline;
} */
.barlow-condensed {
  font-family: 'Barlow Condensed', sans-serif;
  font-weight: bold;
  /* font-size: 2.5rem; */
}

.big-paragraph {
  font-size: 1.25rem; /* Adjust size as per your design */
  margin-top: 1rem;
}

.line-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.line-title-1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.line-title-1::before,
.line-title-1::after {
  content: "";
  flex: 0.17 1;
  height: 2px;
  background-color: #000;
  margin: 0 15px;
}

.line-title-2 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px 0;
}

.line-title-2::before,
.line-title-2::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background-color: #00000094;
  margin: 0 0px;
}

.line-title::before,
.line-title::after {
  content: "";
  flex: 0.1 1;
  height: 1px;
  background-color: #000;
  margin: 0 10px;
}

.line-title span {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

h3 {
  font-weight: bold;
}

info {
  font-size: 12px;
  color: #118a44;

  &.msg {
      color: initial;
      text-align: initial;
      font-weight: bold;
  }
}

.otp-input-fields {
  margin: auto;
  background-color: white;
  max-width: 400px;
  width: auto;
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 20px 40px;

  input {
      height: 40px;
      width: 40px;
      background-color: transparent;
      border-radius: 4px;
      border: 1px solid #2f8f1f;
      text-align: center;
      outline: none;
      font-size: 16px;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
      }

      focus {
          border-width: 2px;
          border-color: darken(#2f8f1f, 5%);
          font-size: 20px;
      }
  }
}

.term {
  position: absolute;
  bottom: 26px;
  right: 6.1rem;
  z-index: 9999;
}


.time-box span {
  font-size: 2.5rem;
}

.time-box small {
  font-size: 0.85rem;
  color: #6c757d;
}

Form Inputs Styling .form-control {
  height: 50px;
  font-size: 1rem;
  padding: 10px 20px;
}

Save Button .btn-dark {
  background-color: #4d4d4d;
  border: none;
}




/* .payment-container {
display: flex;
flex-direction: column;
align-items: center;
background-color: #b2d834;
height: 100vh;
/* justify-content: center; */


.payment-container h2 {
  font-weight: bold;
  margin-bottom: 20px;
  border-bottom: 2px solid black;
  padding-bottom: 10px;
}

.payment-options {
  display: flex;
  gap: 20px;
}

.option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-radius: 12px;
  background-color: white;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 2px solid transparent;
}

.option img {
  height: 30px;
  width: auto;
}

/* .sdsa {
  display: flex;
  justify-content: center;
} */

.Pricing-right{
  text-align: right;
}

/* .Your-order-pricing {
  display: flex;
  gap: 35%;
} */

.Pricing-left h2 {
  font-size: 30px;
  font-weight: bold;
}

.option.active {
  border-color: green;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  transform: scale(1.05);
}




input[type="radio"] {
  accent-color: green;
}





/* Modal.css */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  background: white;
  padding: 20px;
  width: 600px;
  max-width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}

.modal-body {
  margin-top: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.form-control, .form-select {
  height: 53px;
  box-shadow: none !important;
}
.form-control:focus {
}
.btn-primary, .btn-dark {
  background: #453d4d !important;
  border-color: #453d4d !important;
  height: 56px;
  font-size: 18px;
  font-weight: 600;
  align-items: center;
}

.w-fit{
  width: fit-content  ;
}
.bodyScroll{
  overflow: auto;
  height: 100%;
  padding-bottom: 157px !important;
}
.logo-with-text{
  width: 180px;;
}
.mobListCard.p-3 {
  background: #efe0ff;
}
@media (max-width:768px){
  .Pricing-right {
    text-align: left;
}
.footer-container .container {
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.footer-container .container a{
  font-weight: bold;
}
  .smSet{
    flex-direction: column !important;
    justify-content: inherit !important;
  }
  .sm-center{
    text-align: center;
    padding-bottom: 8px;
  }
  .text-sm-center{
    justify-content: center;
    text-align: center !important;
  }
  .bxss{
    justify-content: center !important;
  }
  .text{
    text-align: center !important;
    padding-bottom: 5px;
  }
}
.bxss{
  justify-content: end;
}

.text{
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,sBAAsB,EAAE,+CAA+C;;EAEvE,kCAAkC;EAClC;gFACoE;GACnE,kCAAkC;EACnC,sBAAsB,EAAE,yDAAyD;EACjF,WAAW,EAAE,+CAA+C;EAC5D,4BAA4B;AAC9B;;AAEA;EACE,+EAA+E;AACjF;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,uCAAuC;;AAEzC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;;;AAIA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;;;AAGA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;;GAEG;AACH;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,mCAAmC;EACvD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAU;EACV,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,2BAA2B;EAC3B,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,WAAS;EACT,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;;EAEd;MACI,cAAc;MACd,mBAAmB;MACnB,iBAAiB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;;EAElB;MACI,YAAY;MACZ,WAAW;MACX,6BAA6B;MAC7B,kBAAkB;MAClB,yBAAyB;MACzB,kBAAkB;MAClB,aAAa;MACb,eAAe;;MAEf;;UAEI,wBAAwB;UACxB,SAAS;MACb;;MAEA;UACI,iBAAiB;UACjB,iCAAiC;UACjC,eAAe;MACnB;EACJ;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;;;;AAKA;;;;;;6BAM6B;;;AAG7B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;;GAGG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,sBAAsB;AACxB;;;;;AAKA;EACE,mBAAmB;AACrB;;;;;;AAMA,cAAc;AACd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;AACA;AACA;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;AACpB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;EACE;IACE,iCAAiC;IACjC,mCAAmC;EACrC;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;AACF;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  /* height: 100vh; */\n  display: flex;\n  flex-direction: column; /* Aligns children (main, footer) in a column */\n  \n  /* Corrected gradient background */\n  background: \n   url(/src/Image/signUp-bg.svg), linear-gradient(  #8FB940, #8AC813) ;\n   /* background-repeat: no-repeat; */\n  background-size: cover; /* Optional: Ensures the background covers the viewport */\n  color: #fff; /* Makes text color white for better contrast */\n  background-attachment: fixed;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n\n.top-navbar {\n  background-color: #602998;\n}\n\n.login-btn,\n.signup-btn {\n  height: 35px;\n  padding: 10px 20px;\n  text-align: center;\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 15px;\n  font-weight: 500;\n  text-transform: uppercase;\n  border: 1.4px solid #8FB940;\n  transition: background 0.3s, color 0.3s;\n\n}\n\n.login-btn-active {\n  background-color: #8FB940 !important;\n  color: #fff !important;\n}\n\n.signup-btn {\n  background-color: transparent;\n  color: #8FB940;\n}\n\n.login-btn:hover {\n  background-color: transparent;\n  color: #8FB940;\n}\n\n.signup-btn:hover {\n  background-color: #8FB940;\n  color: #fff;\n}\n\n\n\n.footer-container {\n  position: fixed;\n  /* z-index: 1; */\n  /* margin-top: 2%; */\n  display: flex;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #f8f9fa;\n  padding: 10px 0;\n  border-top: 1px solid #ddd;\n}\n\n\n.footer-container a {\n  text-decoration: none;\n  color: #000;\n}\n\n/* .footer-container a:hover {\n  text-decoration: underline;\n} */\n.barlow-condensed {\n  font-family: 'Barlow Condensed', sans-serif;\n  font-weight: bold;\n  /* font-size: 2.5rem; */\n}\n\n.big-paragraph {\n  font-size: 1.25rem; /* Adjust size as per your design */\n  margin-top: 1rem;\n}\n\n.line-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.line-title-1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.line-title-1::before,\n.line-title-1::after {\n  content: \"\";\n  flex: 0.17;\n  height: 2px;\n  background-color: #000;\n  margin: 0 15px;\n}\n\n.line-title-2 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 15px 0;\n}\n\n.line-title-2::before,\n.line-title-2::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background-color: #00000094;\n  margin: 0 0px;\n}\n\n.line-title::before,\n.line-title::after {\n  content: \"\";\n  flex: 0.1;\n  height: 1px;\n  background-color: #000;\n  margin: 0 10px;\n}\n\n.line-title span {\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n}\n\nh3 {\n  font-weight: bold;\n}\n\ninfo {\n  font-size: 12px;\n  color: #118a44;\n\n  &.msg {\n      color: initial;\n      text-align: initial;\n      font-weight: bold;\n  }\n}\n\n.otp-input-fields {\n  margin: auto;\n  background-color: white;\n  max-width: 400px;\n  width: auto;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  padding: 20px 40px;\n\n  input {\n      height: 40px;\n      width: 40px;\n      background-color: transparent;\n      border-radius: 4px;\n      border: 1px solid #2f8f1f;\n      text-align: center;\n      outline: none;\n      font-size: 16px;\n\n      &::-webkit-outer-spin-button,\n      &::-webkit-inner-spin-button {\n          -webkit-appearance: none;\n          margin: 0;\n      }\n\n      focus {\n          border-width: 2px;\n          border-color: darken(#2f8f1f, 5%);\n          font-size: 20px;\n      }\n  }\n}\n\n.term {\n  position: absolute;\n  bottom: 26px;\n  right: 6.1rem;\n  z-index: 9999;\n}\n\n\n.time-box span {\n  font-size: 2.5rem;\n}\n\n.time-box small {\n  font-size: 0.85rem;\n  color: #6c757d;\n}\n\nForm Inputs Styling .form-control {\n  height: 50px;\n  font-size: 1rem;\n  padding: 10px 20px;\n}\n\nSave Button .btn-dark {\n  background-color: #4d4d4d;\n  border: none;\n}\n\n\n\n\n/* .payment-container {\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\nbackground-color: #b2d834;\nheight: 100vh;\n/* justify-content: center; */\n\n\n.payment-container h2 {\n  font-weight: bold;\n  margin-bottom: 20px;\n  border-bottom: 2px solid black;\n  padding-bottom: 10px;\n}\n\n.payment-options {\n  display: flex;\n  gap: 20px;\n}\n\n.option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 20px;\n  border-radius: 12px;\n  background-color: white;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  border: 2px solid transparent;\n}\n\n.option img {\n  height: 30px;\n  width: auto;\n}\n\n/* .sdsa {\n  display: flex;\n  justify-content: center;\n} */\n\n.Pricing-right{\n  text-align: right;\n}\n\n/* .Your-order-pricing {\n  display: flex;\n  gap: 35%;\n} */\n\n.Pricing-left h2 {\n  font-size: 30px;\n  font-weight: bold;\n}\n\n.option.active {\n  border-color: green;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\n  transform: scale(1.05);\n}\n\n\n\n\ninput[type=\"radio\"] {\n  accent-color: green;\n}\n\n\n\n\n\n/* Modal.css */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-container {\n  background: white;\n  padding: 20px;\n  width: 600px;\n  max-width: 100%;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n}\n\n.modal-body {\n  margin-top: 20px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n.form-control, .form-select {\n  height: 53px;\n  box-shadow: none !important;\n}\n.form-control:focus {\n}\n.btn-primary, .btn-dark {\n  background: #453d4d !important;\n  border-color: #453d4d !important;\n  height: 56px;\n  font-size: 18px;\n  font-weight: 600;\n  align-items: center;\n}\n\n.w-fit{\n  width: fit-content  ;\n}\n.bodyScroll{\n  overflow: auto;\n  height: 100%;\n  padding-bottom: 157px !important;\n}\n.logo-with-text{\n  width: 180px;;\n}\n.mobListCard.p-3 {\n  background: #efe0ff;\n}\n@media (max-width:768px){\n  .Pricing-right {\n    text-align: left;\n}\n.footer-container .container {\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n.footer-container .container a{\n  font-weight: bold;\n}\n  .smSet{\n    flex-direction: column !important;\n    justify-content: inherit !important;\n  }\n  .sm-center{\n    text-align: center;\n    padding-bottom: 8px;\n  }\n  .text-sm-center{\n    justify-content: center;\n    text-align: center !important;\n  }\n  .bxss{\n    justify-content: center !important;\n  }\n  .text{\n    text-align: center !important;\n    padding-bottom: 5px;\n  }\n}\n.bxss{\n  justify-content: end;\n}\n\n.text{\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
